<template>
  <el-button
    v-if="row.communityManager && row.communityManager.id"
    @click="clickButton(row.communityManager.id)"
  >
    {{ `${row.communityManager.firstName} ${row.communityManager.lastName}` }}
  </el-button>
</template>

<script lang="ts">
import {
  defineComponent, PropType,
} from 'vue';

export default defineComponent({
  name: 'CommunityManagerLink',
  props: {
    row: {
      type: Object as PropType<any>,
      required: true,
    },
    column: {
      type: Object as PropType<any>,
      required: true,
    },
  },
  setup () {
    const clickButton = (communityManagerId) => {
      window.open(`/residents/${communityManagerId}`, '_blank');
    };

    return {
      clickButton,
    };
  },
});
</script>
